<template>
  <div>
    <div class="warehousingManagePage">
      <div class="banner">
        <img src="../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">SKU管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">库存管理</div>
      </div>
      <div class="operation_wrap">
        <div class="input_wrap flex-rowl">
          <div class="input_box flex-rowl">
            <!-- <input type="text" v-mtfocus placeholder="输入SKU编码/ISBN编码查找匹配商品" > -->
            <van-field
              v-model="params.keyword"
              ref="input"
              @focus="handleFocus"
              @blur="handleBlur"
              placeholder="输入SKU编码/商品名称"
            />
            <span class="iconfont icon-saoma" @click="handleSance"></span>
          </div>
          <div class="primary-button" @click="handleSearch">查找→</div>
        </div>
        <div class="txt">
          <p>Step-01 输入商品名称或SKU ID，查找目标商品；</p>
          <p>Step-02 获得查找结果后，可对商品库存进行管理；</p>
        </div>
      </div>

      <div class="main_content">
        <div class="data_list" v-if="dataList.length > 0">
          <div class="item_card" v-for="item in dataList" :key="item.id">
            <!-- <div class="block">
              <h1>商品ID：{{ item.id }}</h1>
            </div> -->
            <div class="block">
              <h1>商品名称：{{ item.commodityname }}</h1>
              <p>{{ item.commodityname_e }}</p>
              <p>{{ item.commodityname_y }}</p>
              <p>{{ item.commodityname_m }}</p>
              <p>{{ item.commodityname_t }}</p>
            </div>
            <div class="img_box" @click="handleEdit(item.ISBN, item.id)">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="item.img"
              />
            </div>
            <div class="block">
              <p>
                SKU采购编码：{{ item.sku }}
                <span
                  class="copy_box"
                  :data-clipboard-text="item.sku"
                  @click="handleCopyBtn"
                  ><i class="iconfont icon-fuzhi"></i
                ></span>
              </p>
              <p>品牌标签：{{ item.brandname ? item.brandname : "" }}</p>
              <p>
                ISBN编码：{{ item.ISBN }}
                <span
                  class="copy_box"
                  :data-clipboard-text="item.ISBN"
                  @click="handleCopyBtn"
                  ><i class="iconfont icon-fuzhi"></i
                ></span>
              </p>

              <!-- <p>是否上架：{{ item.commoditystate }}</p>
              <p>销售状态：{{ item.salestate }}</p>
              <p>
                限购状态：<span v-if="item.islimit">{{
                  item.islimit == "不限购"
                    ? item.islimit
                    : "每人限购/" + item.limitnum + "件"
                }}</span>
              </p> -->
            </div>
            <div class="block">
              <p>
                商品所属企业：{{
                  item.qyname ? item.qyname : item.qy_accountid
                }}
              </p>
              <p>当前库存总量：{{ item.kunum }}</p>
            </div>

            <div class="operation">
              <p>
                添加日期：<span>{{ item.createdate | formatDate }}</span>
              </p>
              <p>
                操作人员：<span>{{ item.createman }}</span>
              </p>
            </div>
            <div class="editBtn" @click="handleEdit(item.ISBN, item.id)">
              库存管理→
            </div>
          </div>
        </div>
        <van-empty description="暂无数据" v-else />
      </div>

      <!-- <div class="primary-button-plain" @click="handleToast">入库计划</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div> -->
    </div>
    <div class="fixd_button_btm" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item" @click="handleReturn">返回</div>
      <!-- <div class="item" @click="handleToast">添加库存</div> -->
    </div>
    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
    <router-view></router-view>
  </div>
</template>

<script>
let previousRouterName = "";
let previTxt = "";
import {
  queryShop,
  getMenuAuthTwo,
  getMenuAuthThree,
  encryptstringadd,
} from "../../api/api";
import { mapState } from "vuex";
import Clipboard from "clipboard";
// import Tabbar from "../../components/Tabbar.vue";
export default {
  name: "wManageIndex",
  components: {
    // Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      dataList: [],
      params: {
        keyword: "",
        openid: "",
        qyguid: "",
        pageindex: 1,
        pagesize: 10,
      },
      listTotal: 0,
      loading: false, // 是否正在加载中
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  // back 返回页获取参数
  beforeRouteEnter(to, from, next) {
    console.log(to);
    previousRouterName = from.name;
    if (from.name === "qrcode") {
      previTxt = from.params.keyword;
    }
    next();
  },
  created() {
    this.roleId = this.$store.state.USERINFO.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.params.qyguid = this.$store.state.USERINFO.qy.qyguid;
    this.getMenuAuthTwo();

    if (previousRouterName === "qrcode") {
      this.params.keyword = previTxt;
    }
  },
  mounted() {
    this.getShop(); // 初始化加载数据
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },
    // 获取按钮权限
    getMenuAuthThree() {
      let { menuItem } = this;
      getMenuAuthThree(menuItem.id).then((res) => {
        if (res.length == 0) return;
      });
    },

    handleToast() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      this.$toast("即将开放");
      return;
    },

    handleReturn() {
      this.$router.go(-1);
    },

    handleSearch() {
      if (this.params.keyword == "") {
        this.$toast("请输入SKU编码/ISBN编码");
        return;
      } else {
        this.dataList = [];
        this.params.pageindex = 1;
        this.getShop();
      }
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getShop();
      }
    },
    getShop() {
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      this.loading = true;
      queryShop(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        toast.clear();
      });
    },
    handleEdit(ISBN, id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      // this.$router.push(`/warehousIndex/wManageDetail/${ISBN}/${id}`);
      this.encryptstringadd("wManageDetail", { keyword: ISBN, cmid: id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 跳转扫码
    handleSance() {
      this.$router.push("/Qrcode");
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingManagePage {
  .operation_wrap {
    padding: 20px 45px 50px;
    .input_wrap {
      box-sizing: border-box;
      margin-bottom: 30px;
      .primary-button {
        width: 145px;
        margin-left: 20px;
        font-size: 26px;
      }
    }
    .primary-button-plain {
      margin-top: 59px;
    }
    .txt {
      font-size: 24px;
      color: red;
      padding-left: 20px;
      box-sizing: border-box;
      p {
        margin-bottom: 15px;
        // text-align: center;
      }
    }
  }

  .main_content {
    width: 650px;
    margin: 0 auto 100px;
    padding-bottom: 190px;
    .data_list {
      // padding-bottom: 320px;
      .item_card {
        border: 2px solid #dedede;
        border-radius: 30px;
        padding: 45px 37px 87px;
        box-sizing: border-box;
        font-size: 22px;
        color: #404d6c;
        position: relative;
        margin-bottom: 55px;
        .block {
          margin-bottom: 30px;
        }
        .img_box {
          width: 250px;
          height: 250px;
          margin: 35px auto;
          background: #f8f8f8;
          overflow: hidden;
        }
        h1 {
          font-size: 30px;
          color: #404d6c;
          margin-bottom: 12px;
        }
        p {
          margin-bottom: 10px;
        }
        .editBtn {
          width: 200px;
          height: 50px;
          background: #6e5c86;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #fff;
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
    }
  }
}
</style>